const internalPaths = [
  '/admin',
  '/signup',
  '/login',
  '/settings',
  '/account',

  '/checkout',
  '/c/',
  '/overlay',
  '/s/',
  '/subscriptions',
  '/submissions',
  '/pages',
  '/checkouts',
  '/events',
  '/forms',
  '/bookings',
  '/attendees',
  '/customers',
  '/link-in-bio',
  '/coupons',
  '/seller',
  '/orders',
  '/payments',
  '/upgrade',
  '/logout',
  '/setup',
];

function parseTo(href) {
  const parser = document.createElement('a');
  parser.href = href;
  return parser;
}

export default function isInternalLink(href) {
  const toLocation = parseTo(href);

  if (window.location.host !== toLocation.host) {
    return false;
  }

  return internalPaths.some(path => toLocation.pathname.startsWith(path));
}
